'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.projectStatus = exports.quickSendBox = exports.projectTypes = exports.pageLimit = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

exports.getProjectStatusTexts = getProjectStatusTexts;
exports.getProjectStatusText = getProjectStatusText;
exports.prepareProject = prepareProject;
exports.processProject = processProject;
exports.processProjects = processProjects;
exports.prepareProjects = prepareProjects;
exports.getFilteredProjects = getFilteredProjects;
exports.getProjectPermissions = getProjectPermissions;
exports.transformProjectsResponse = transformProjectsResponse;

var _TypeCast = require('helpers/TypeCast');

var _strings = require('helpers/strings');

var _datetime = require('helpers/datetime');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _utils = require('helpers/utils');

var _recipients = require('helpers/recipients');

var _Playlists = require('helpers/Playlists');

var _ordering = require('utils/ordering');

var _ordering2 = _interopRequireDefault(_ordering);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pageLimit = exports.pageLimit = 100;

var filteredFields = ['artist_name', 'titleName1', 'titleName2', 'owName', 'projectId', 'iRef', 'statusText'];

var projectTypes = exports.projectTypes = {
  quickSend: 'QS',
  audio: 'audio',
  video: 'video',
  sharespace: 'sharespace',
  newsletter: 'newsletter',
  all: 'all'
};

var quickSendBox = exports.quickSendBox = {
  inbox: 'inbox',
  sent: 'sent',
  draft: 'draft'
};

var projectStatus = exports.projectStatus = {
  created: 'Created',
  draft: 'Draft',
  suspended: 'Suspended',
  toProcess: 'toProcess',
  active: 'Active',
  expired: 'Expired',
  deleted: 'Deleted',
  published: 'Published',
  hidden: 'hidden'
};

var projectStatusTexts = null;

function getProjectStatusTexts() {
  if (!projectStatusTexts) {
    var _projectStatusTexts;

    var t = require('i18n-universal').getT();
    projectStatusTexts = (_projectStatusTexts = {}, (0, _defineProperty3.default)(_projectStatusTexts, projectStatus.created, t('Pending')), (0, _defineProperty3.default)(_projectStatusTexts, projectStatus.draft, t('Pending')), (0, _defineProperty3.default)(_projectStatusTexts, projectStatus.suspended, t('Suspended')), (0, _defineProperty3.default)(_projectStatusTexts, projectStatus.toProcess, t('Processing')), (0, _defineProperty3.default)(_projectStatusTexts, projectStatus.active, t('Published')), (0, _defineProperty3.default)(_projectStatusTexts, projectStatus.expired, t('Expired')), (0, _defineProperty3.default)(_projectStatusTexts, projectStatus.deleted, t('Deleted')), (0, _defineProperty3.default)(_projectStatusTexts, projectStatus.published, t('Published')), (0, _defineProperty3.default)(_projectStatusTexts, projectStatus.hidden, t('hidden')), _projectStatusTexts);
  }

  return projectStatusTexts;
}

function getProjectStatusText(project) {
  return getProjectStatusTexts()[project.status];
}

function prepareProject(project) {
  var _ref = project || {},
      mainProject = _ref.mainProject;

  var processedProject = {};
  if (mainProject) {
    processedProject = (0, _extends3.default)({}, project, mainProject);
    delete processedProject.mainProject;
  } else {
    processedProject = (0, _extends3.default)({}, project);
  }

  // duct tape for the API that has a different names for the same fields in the different requests
  var _processedProject = processedProject,
      track_name = _processedProject.track_name,
      track_name2 = _processedProject.track_name2,
      title = _processedProject.title,
      title2 = _processedProject.title2,
      album = _processedProject.album,
      album2 = _processedProject.album2;

  var titleName1 = track_name || title || album; // eslint-disable-line camelcase
  var titleName2 = track_name2 || title2 || album2; // eslint-disable-line camelcase

  processedProject.titleName1 = titleName1;
  processedProject.titleName2 = titleName2;

  processedProject.projectId = processedProject.projectId || processedProject.project_id || processedProject.id;
  processedProject.owName = (0, _strings.concat)(' ', processedProject.owFirstname || processedProject.ownerFirstname || processedProject.ownerName, processedProject.owLastname || processedProject.ownerLastname || processedProject.ownerSurname);
  processedProject.fullTitle = (0, _strings.concat)(' : ', processedProject.artist_name, (0, _strings.concat)(' ', titleName1, titleName2));
  processedProject.projectContentType = processedProject.projectType === 'root_project' ? projectTypes.sharespace : processedProject.audiovideo;
  processedProject.statusText = getProjectStatusText(processedProject);
  processedProject._isPrepared = true;

  return processedProject;
}

function processProject(project) {
  var processedProject = (0, _get3.default)(project, '_isPrepared', false) ? (0, _extends3.default)({}, project) : prepareProject(project);

  processedProject.canEdit = (0, _TypeCast.asBoolean)(processedProject.canEdit);
  processedProject.lockedSharespace = (0, _TypeCast.asNumberArray)(processedProject.lockedSharespace);
  processedProject.directAccessWatermark = processedProject.directAccessWatermark || 0;
  processedProject.hideSender = processedProject.hideSender || 0;
  processedProject.watermarkTracks = !!processedProject.watermarkTracks;
  processedProject.expiryDate = (0, _datetime.formatDateToSql)(processedProject.expiryDate);
  processedProject.expiryDateText = processedProject.expiryDate ? (0, _moment2.default)(processedProject.expiryDate).format(_datetime.dateFormat.date) : '';
  processedProject.shortExpiryDateText = processedProject.expiryDate ? (0, _datetime.formatShortDate)(processedProject.expiryDate) : '';
  processedProject.isExpired = (0, _datetime.isExpired)({ time: 0, duration: new Date(processedProject.expiryDate) });
  processedProject.sentDate = processedProject.sentDate || processedProject.sent_date || (0, _get3.default)(processedProject, ['recipients', 0, 'sent_date']);
  processedProject.sentDateText = processedProject.sentDate ? (0, _moment2.default)(processedProject.sentDate).format(_datetime.dateFormat.date) : '';
  processedProject.sentDateTimeText = processedProject.sentDate ? (0, _moment2.default)(processedProject.sentDate).format(_datetime.dateFormat.dateTime) : '';
  processedProject.releaseDate = (0, _datetime.formatDateToSql)(processedProject.releaseDate);
  processedProject.impactDate = (0, _datetime.formatDateToSql)(processedProject.impactDate);
  processedProject.dispatchDate = (0, _datetime.formatDateTimeToSql)(processedProject.dispatchDate, true);

  if (processedProject.recipients) {
    processedProject.recipients = (0, _recipients.processRecipients)((0, _TypeCast.asArray)(processedProject.recipients));
  }
  if (processedProject.tracks) {
    processedProject.tracks = (0, _Playlists.processTracks)({ tracks: (0, _TypeCast.asArray)(processedProject.tracks) });
  }

  return processedProject;
}

function processProjects(projects) {
  console.time('processProjects');
  var result = projects.map(processProject);
  console.timeEnd('processProjects');
  return result;
}

function prepareProjects(projects) {
  console.time('prepareProjects');
  var result = projects.map(prepareProject);
  console.timeEnd('prepareProjects');
  return result;
}

function getFilteredProjects(projects, activeOrder, order, kw) {
  console.time('getFilteredProjects');
  var res = (0, _utils.filterObjectsByKws)({ objects: projects, fields: filteredFields, kw: kw });
  console.timeEnd('getFilteredProjects');
  return (0, _ordering2.default)({ data: res, activeOrder: activeOrder, order: order });
}

function getProjectPermissions(_ref2) {
  var project = _ref2.project,
      userPermissions = _ref2.userPermissions;

  var permissions = {};
  var isSharespace = project.projectContentType === projectTypes.sharespace;

  permissions.canDelete = isSharespace ? project.canEdit : true;
  permissions.canEdit = project.canEdit;
  permissions.canGetReport = project.projectContentType === projectTypes.audio && userPermissions.statsEnable;
  permissions.canCreateSubproject = isSharespace && !project.canEdit;

  return permissions;
}

function transformProjectsResponse(resp) {
  (0, _get3.default)(resp, 'data.listOfMasterProject', []).map(function (project) {
    project.id = (0, _get3.default)(project, 'mainProject.id');
  });

  return resp;
}


//////////////////
// WEBPACK FOOTER
// ./src/helpers/projects.js
// module id = 28
// module chunks = 1